import request from '@/utils/request'
const BASE_URL = '/SourceType'

//类别
export default {
  list(data) {
    return request({
        url: BASE_URL + '/List',
        method: 'post',
        data
      })
  },
  async info(name) {
    // 缓存
    let cache=sessionStorage.getItem("sourceType")
    if(cache==null || cache=='undefined')
    {
        return await this.list({}).then(res=>{
        if(res.Code==0){
          sessionStorage.setItem("sourceType", JSON.stringify(res.Data));
          let index= res.Data.findIndex(item=>item.SourceType==name)
          return res.Data[index]
        }
       })
    }
    else
    {
      let result=JSON.parse(cache)
      let index= result.findIndex(item=>item.SourceType==name)
      return result[index]
    }
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data: id 
    })
  }
}